module.exports = __webpack_public_path__ + "img/pIndex-wx-h.6982deb8.png";